<template>
    <div class="meta-ir">
        <div class="meta-ir__overlay" />

        <div class="meta-ir__header">
            <span>Reels</span>
            <Icon type="logo-instagram" />
        </div>

        <div class="meta-ir__content">
            <div class="post_media single">
                <slot />
            </div>

            <div class="meta-ir__overlay-content">
                <div class="meta-ir__info">
                    <div class="meta-ir__info-moving">
                        <div class="meta-ir__info-title">
                            <Icon type="logo-instagram" />
                            <span>Business Name</span>
                        </div>

                        <button v-if="metaOverwrites?.fbCallToAction" class="meta-ir__info-btn">
                            {{ metaOverwrites.fbCallToAction }}
                            <span>&#10095;</span>
                        </button>
                    </div>

                    <div v-if="metaOverwrites?.fbPrimaryText" class="meta-ir__info-text">
                        {{ metaOverwrites?.fbPrimaryText }}
                    </div>

                    <div class="meta-ir__footer__buttons">
                        <span>
                            <Icon type="ios-megaphone" />
                            Sponsored
                        </span>

                        <span>
                            <Icon type="md-musical-note" />
                            Original audio
                        </span>
                    </div>
                </div>

                <div class="meta-ir__action-buttons">
                    <Icon type="ios-heart-outline" />
                    <Icon type="ios-chatbubbles-outline" />
                    <Icon type="ios-send-outline" />
                    <Icon type="ios-more" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { MasterTemplate } from "shared-types";

import { AdSubType } from "@/enums/assemble";
import type { MetaOverwrites } from "@/types/types";

export default defineComponent({
    name: "InstagramReel",
    props: {
        metaOverwrites: {
            type: Object as PropType<MetaOverwrites>,
            default: () => ({})
        },

        adSubType: {
            type: String as PropType<(typeof AdSubType)[keyof typeof AdSubType]>,
            default: AdSubType.Video
        },

        masterTemplate: {
            type: Object as PropType<MasterTemplate>
        },

        adSize: {
            type: Number
        }
    }
});
</script>

<style lang="scss">
.meta-ir {
    width: 100%;
    display: flex;
    flex-direction: column;

    .meta-ir__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: linear-gradient(
            180deg,
            rgba(149, 149, 149, 1) 0%,
            rgba(255, 255, 255, 0) 25%,
            rgba(255, 255, 255, 0) 75%,
            rgba(149, 149, 149, 1) 100%
        );
    }

    .meta-ir__header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 2;
        display: flex;
        align-items: center;
        padding: 20px 10px 10px;
        color: #fff;
        font-size: 24px;
        font-weight: bold;

        i {
            margin-left: auto;
            font-size: 32px;
        }
    }

    .meta-ir__content {
        flex: 1;

        display: flex;

        .post_media {
            width: 100%;
            display: flex;
        }

        .banner-preview {
            align-items: center;

            .iframe-container {
                height: 100%;
            }
        }
    }

    .meta-ir__overlay-content {
        z-index: 1;
        width: 100%;

        position: absolute;
        bottom: 0;

        display: flex;
        gap: 10px;
        padding: 0 10px 20px;

        .meta-ir__info {
            flex: 1;

            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            gap: 8px;

            color: #fff;

            .meta-ir__info-moving {
                display: flex;
                flex-direction: column;
                gap: 10px;

                position: relative;
                bottom: -20px;

                animation: disappear-reappear-title 10s linear infinite;
            }

            .meta-ir__info-title {
                display: flex;
                align-items: center;
                gap: 5px;

                font-weight: bold;

                i {
                    font-size: 34px;
                    margin-left: -3px;
                }
            }

            .meta-ir__info-btn {
                display: flex;

                padding: 5px 10px;

                border: none;
                border-radius: 4px;
                width: 100%;
                font-size: 12px;
                color: #fff;
                background: #b6b6b6;

                animation: disappear-reappear-button 10s linear infinite;

                span {
                    display: inline-block;
                    margin-left: auto;
                }
            }

            .meta-ir__footer__buttons {
                display: flex;
                gap: 10px;

                span {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #fff;
                    border-radius: 10px;
                    padding: 3px 5px;
                    background: #878787;

                    i {
                        font-size: 16px;
                        margin-right: 5px;
                    }
                }
            }
        }

        .meta-ir__action-buttons {
            display: flex;
            flex-direction: column;
            gap: 10px;

            i {
                font-size: 34px;
                font-weight: bold;
                color: #fff;
            }
        }
    }
}

@keyframes disappear-reappear-button {
    0% {
        opacity: 0;
    }
    35% {
        opacity: 0;
    }
    40% {
        opacity: 1;
        color: #fff;
        background: #b6b6b6;
    }
    50% {
        opacity: 1;
        color: #2a2a2a;
        background: #fff;
    }

    99% {
        opacity: 1;
        color: #2a2a2a;
        background: #fff;
    }

    100% {
        opacity: 0;
        color: #fff;
        background: #b6b6b6;
    }
}
@keyframes disappear-reappear-title {
    0% {
        bottom: -40px;
    }
    35% {
        bottom: -40px;
    }
    40% {
        bottom: 0;
    }
    100% {
        bottom: 0;
    }
}
</style>
